export interface Feedback {
  id: number;
  rating: number;
  comment: string;
  surveyId?: number;
  digitalSurveyId?: number;
}

export type FeedbackViewType = Pick< Feedback, 'id' | 'rating' | 'comment'>

export interface FeedbackState {
  feedbackList?: Feedback[];
}

export const SET_FEEDBACK_LIST = 'SET_FEEDBACK_LIST';
type GetFeedbacks = {
  type: typeof SET_FEEDBACK_LIST;
  payload: Feedback[];
}

export type FeedbackActionType = GetFeedbacks;
